export default __webpack_public_path__ + "static/media/bonito.8dce98aa.jpeg";